<template>
  <div class="text-center" v-if="snackbar">
    <v-snackbar v-model="snackbar" color="primary" :multi-line="false" dark>
      <span class="white--text">{{ text }}</span>
      <v-btn color="white" text @click="displaySnackbar()" class="pl-0">
        <v-icon class="icon-forma-1-2 display-16" color="white" />
      </v-btn>
    </v-snackbar>
  </div>
</template>


<script>
import { t } from '@/store/modules/homeDrushim/constantsContent';

export default {
  data: () => ({
    snackbar: false,
    text: t('tooltips.addToFavorites'),
  }),

  mounted() {
    this.$nuxt.$on('showsnack', this.displaySnackbar);
  },
  beforeDestroy() {
    this.$nuxt.$off('showsnack');
  },
  methods: {
    displaySnackbar() {
      this.snackbar = !this.snackbar;
    },
  },
};
</script>

<style lang="scss" scoped>
$snackbar-content-padding: 5px;
</style>